export interface ConfigStateInterface {
  id: number
  slug: string
  name: string | null
  description: string | null
  image: string | null
  endpoint: string | null
}

function state(): ConfigStateInterface {
  return {
    id: 0,
    slug: '',
    name: null,
    description: null,
    image: null,
    endpoint: null,
  }
}

export default state
